export default "__VITE_ASSET__35a68a3f__"